"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = require("react");
const useStyle = (props) => {
    const theme = (0, material_1.useTheme)();
    const finalSquareBgColor = props.success
        ? theme.palette.success.light
        : props.error
            ? theme.palette.error.main
            : props.squareBgColor;
    const finalIconColor = props.success || props.error ? '#ffffff' : props.iconColor;
    const finalCircleBgColor = props.success ? '#47b84e' : props.error ? '#de1b28' : props.circleBgColor;
    const squareStyle = (0, react_1.useMemo)(() => ({
        width: props.squareSize,
        height: props.squareSize,
        backgroundColor: finalSquareBgColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transform: 'rotate(45deg)',
        borderRadius: '9px',
    }), [props.squareSize, finalSquareBgColor]);
    const iconStyle = (0, react_1.useMemo)(() => ({
        color: finalIconColor,
        transform: 'rotate(-45deg)',
        backgroundColor: finalCircleBgColor,
        padding: '0.2rem',
        height: props.IconSize,
        width: props.IconSize,
        borderRadius: '50%',
    }), [finalIconColor, finalCircleBgColor, props.IconSize]);
    return { squareStyle, iconStyle };
};
exports.default = useStyle;
